/**
 * Entry point: mounts the application, then wires the installable layer.
 *
 * The service worker registers immediately (auto-update strategy: a new
 * deploy takes over once precached, with no prompt machinery — the client
 * is stateless between reloads apart from stored accounts, which are
 * schema-safe). Manifest branding rewrites the install name per hostname
 * and is fire-and-forget: on failure the static manifest stands.
 */
import { render } from "preact";
import { registerSW } from "virtual:pwa-register";

import { App } from "./app.tsx";
import { brandManifest } from "./brand-manifest.ts";
import "./styles/app.css";

const root = document.querySelector("#app");
if (root === null) {
  throw new Error("index.html is missing its #app mount point.");
}
render(<App />, root);

registerSW({ immediate: true });
void brandManifest();
